module.exports = __webpack_public_path__ + "assets/img/tab2_07.957d8a50.jpg";